export default class UserViewController {
  constructor(UsersDataProvider, $state, $timeout, APPLICATION_URL) {
    "ngInject"
    this.UsersDataProvider = UsersDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.APPLICATION_URL = APPLICATION_URL;
    this.errorShow = 0;
    this.activeTab = 1;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = {10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All'};
    this.field = 'id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    let
      vm = this;
    vm.open1 = function () {
      vm.popup1.opened = true;
    };
    vm.open2 = function () {
      vm.popup2.opened = true;
    };
    vm.format = 'yyyy-MM-dd';
    vm.altInputFormats = ['M!/d!/yyyy'];
    vm.popup1 = {
      opened: false
    };
    vm.popup2 = {
      opened: false
    };
    UsersDataProvider.getUser($state.params.id).then(function (result) {
      vm.data = result;
      let
        theUrl = vm.APPLICATION_URL + '/api/get/countries';
      let
        xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", theUrl, false); // false for synchronous request
      xmlHttp.send(null);
      let
        resp = JSON.parse(xmlHttp.response);
      if (vm.data.country)
        vm.countryName = resp[vm.data.country];
      vm.getOrders();
      UsersDataProvider.getComments($state.params.id).then(function (comments) {
        vm.comments = comments;
      });
    });
  }

  getSortRecors(field, order_type, col, colTopDown) {
    this.field = field;
    this.order_type = order_type;
    this.col = col;
    this.colTopDown = colTopDown;
    this.getOrders();
  }

  getOrders() {
    let
      vm = this;
    let
      data = {};
    let
      searchData = {};
    searchData.user_id = vm.$state.params.id;
    searchData.orderId = vm.orderId;
    searchData.from = vm.from;
    searchData.to = vm.to;
    searchData.price_from = vm.price_from;
    searchData.price_to = vm.price_to;
    searchData.orderType = vm.orderType;
    data.searchData = searchData;
    data.currentPage = vm.currentPage;
    data.pageLimit = vm.pageLimit;
    data.field = vm.field;
    data.order_type = vm.order_type;
    vm.UsersDataProvider.getOrders(data).then(function (result) {
      vm.orders = result.data;
      vm.ordersTotal = result.total;
    });
  }

  clearFilter() {
    this.orderId = '';
    this.price_to = '';
    this.price_from = '';
    this.orderType = '';
    this.to = '';
    this.from = '';
    this.getOrders();
  }

  setActiveTab(tabToSet) {
    this.activeTab = tabToSet;
  }

  saveComment() {
    if (this.comment) {
      let
        vm = this;
      let
        saveData = {'from_id': '0', 'user_id': vm.data.id, 'comment': vm.comment}
      vm.UsersDataProvider.saveComments(saveData).then(function (res) {
        if (res.exist == '0') {
          vm.comments.push(res);
        }
      });
    }
  }

  removeComment(cid) {
    let
      vm = this;
    vm.UsersDataProvider.removeComment(cid).then(function (res) {
      let
        index = vm.comments.findIndex(function (el) {
          return (el.id === cid);
        });
      if (index !== -1) {
        vm.comments.splice(index, 1);
      }
    });
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/users/components/view/controller.js
 **/